import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import { BankTransferState } from '../types'
import * as actions from './actions'
import initialState from './initialState'

const initBankTransfer = (state: BankTransferState): BankTransferState => {
  return {
    ...state,
  }
}

const fetchBankListStart = (state: BankTransferState): BankTransferState => ({
  ...state,
  initStatus: LoadingStates.Loading,
})

const fetchBanksListSuccess = (
  state: BankTransferState,
  { bankInfos }: { bankInfos: BankTransferState['bankInfos'] | null },
): BankTransferState => {
  return {
    ...state,
    bankInfos,
    initStatus: LoadingStates.LoadedSuccess,
  }
}

const fetchBanksListFail = (state: BankTransferState): BankTransferState => ({
  ...state,
  initStatus: LoadingStates.LoadedFail,
})

const setSelectedBankId = (state: BankTransferState, bankId: string): BankTransferState => ({
  ...state,
  selectedBankId: bankId,
})

const setErrorState = (state: BankTransferState, value: boolean): BankTransferState => ({
  ...state,
  showError: value,
})

const setShouldShowBankSelectionPopup = (
  state: BankTransferState,
  value: boolean,
): BankTransferState => ({
  ...state,
  showBankSelectionPopup: value,
})

export default createReducer((on) => {
  on(actions.initBankTransfer, initBankTransfer)
  on(actions.fetchBankListStart, fetchBankListStart)
  on(actions.fetchBanksListSuccess, fetchBanksListSuccess)
  on(actions.fetchBanksListFail, fetchBanksListFail)
  on(actions.setSelectedBankId, setSelectedBankId)
  on(actions.setErrorState, setErrorState)
  on(actions.showBankSelectionPopup, setShouldShowBankSelectionPopup)
}, initialState)
